import axios from 'axios'
import { eventHub } from '../utils/eventhub'
axios.defaults.baseURL = '/qmaticwebbooking/rest/schedule'
axios.defaults.headers.post['Content-Type'] = 'application/json'
axios.interceptors.response.use(
  response => {
    return response
  },
  error => {
    eventHub.$emit('show-error-message', error)
    return Promise.reject(error)
  }
)
export default {
  name: 'RestService',
  methods: {
    getUrl: function (baseUrl, services) {
      var url = baseUrl
      for (var j = 0; j < services.length; j++) {
        var serviceId = services[j].publicId
        url = url + ';servicePublicId=' + serviceId
      }
      return url
    },
    getMessages: function (language) {
      return axios.get('/uiMessages?lang=' + language)
    },
    // get configuration saved from Admin UI
    getConfiguration: function () {
      return axios.get('/configuration', {
        headers: {
          'Cache-Control': 'no-cache, no-store, must-revalidate',
          'Expires': '0'
        }
      })
    },
    getServices: function () {
      return axios.get('/services')
    },
    getBranchesBySingleService: function (serviceId) {
      return axios.get('/services/' + serviceId + '/branches')
    },
    getBranchesByServices: function (selectedServices) {
      if (selectedServices) {
        var baseUrl = '/branches/available'
        var url = this.getUrl(baseUrl, selectedServices)
        return axios.get(url)
      } else { return axios.get('/branches') }
    },
    getServicesByBranch: function (branchId) {
      return axios.get('branches/' + branchId + '/services')
    },
    getBranchGroups: function (selectedServices) {
      var baseUrl = '/branchGroups'
      var url
      if (selectedServices) {
        url = this.getUrl(baseUrl, selectedServices)
      } else {
        url = baseUrl
      }
      return axios.get(url)
    },
    getServiceGroups: function () {
      return axios.get('serviceGroups')
    },
    getServiceGroupsByBranch: function (branchId) {
      return axios.get('branches/' + branchId + '/serviceGroups')
    },
    getServiceTemplates: function () {
      return axios.get('serviceTemplates')
    },
    getAvailableDates: function (selectedBranchId, selectedServices, customSlotLength) {
      var baseUrl = '/branches/' + selectedBranchId + '/dates'
      var url = this.getUrl(baseUrl, selectedServices)
      url = url + ';customSlotLength=' + customSlotLength
      return axios.get(url)
    },
    getAvailableTimes: function (date, selectedServices, customSlotLength, selectedBranchId) {
      var baseUrl = '/branches/' + selectedBranchId + '/dates/' + date + '/times'
      var url = this.getUrl(baseUrl, selectedServices)
      url = url + ';customSlotLength=' + customSlotLength
      return axios.get(url)
    },
    reserveTimeSlot: function (selectedBranch, date, time, customSlotLength, selectedServices, securityToken) {
      var data = {}
      var slotString = ''
      data.services = []
      for (var i = 0; i < selectedServices.length; i++) {
        var service = {}
        service.publicId = selectedServices[i].publicId
        data.services.push(service)
      }
      // add the list of services for calculation on the backend
      data.custom = {}
      data.custom.peopleServices = []
      for (let j = 0; j < selectedServices.length; j++) {
        let peopleService = selectedServices[j]
        var customObject = {}
        customObject.publicId = peopleService.publicId
        customObject.qpId = peopleService.qpId
        customObject.adult = peopleService.adult
        customObject.name = peopleService.name
        customObject.child = peopleService.child
        data.custom.peopleServices.push(customObject)
      }
      data.custom = JSON.stringify(data.custom)
      // add the precalculated customSlotLength (will be calculated again in the backend)
      slotString += ';customSlotLength=' + customSlotLength
      var json = JSON.stringify(data)
      var url = '/branches/' + selectedBranch.id + '/dates/' + date + '/times/' + time + '/reserve' + slotString
      // axios.default.headers.post['X-CSRF-Token'] = securityToken

      return axios.post(url, json, {
        headers: { 'X-CSRF-Token': securityToken } }
      )
    },
    sendVerificationCode: function (phoneNumber, securityToken) {
      var data = {}
      var json
      data.phoneNumber = phoneNumber
      json = JSON.stringify(data)
      return axios.post('/sendSMS', json, {
        headers: { 'X-CSRF-Token': securityToken } }
      )
    },
    verifyPhoneNumber: function (code, phoneNumber, securityToken) {
      var data = {}
      var json
      data.phoneNumber = phoneNumber
      data.message = code.toString()
      json = JSON.stringify(data)
      return axios.post('/verifySMS', json, {
        headers: { 'X-CSRF-Token': securityToken } }
      )
    },
    confirmAppointment: function (selectedServices, reservedAppointmedId, contactDetails, languageCode, recaptchaToken, totalCost, customSlotLength, notificationType, customProperties, notes, securityToken) {
      var url = '/appointments/' + reservedAppointmedId + '/confirm'
      var createdByUser = 'Qmatic Web Booking'
      var data = {
        customer: {
          firstName: '',
          lastName: '',
          dateOfBirth: '',
          email: '',
          phone: '',
          dob: '',
          allowOverwrite: false
        },
        languageCode: '',
        notificationType: '',
        captcha: '',
        custom: {
          peopleServices: [],
          totalCost: 0,
          createdByUser: createdByUser
        },
        notes: '',
        title: createdByUser
      }
      for (var i = 0; i < selectedServices.length; i++) {
        var service = selectedServices[i]
        var customObject = {}
        customObject.publicId = service.publicId
        customObject.qpId = service.qpId
        customObject.adult = service.adult
        customObject.name = service.name
        customObject.child = service.child
        data.custom.peopleServices.push(customObject)
      }
      data.custom.totalCost = totalCost
      data.custom.customSlotLength = customSlotLength
      for (let myProperty in customProperties) {
        data.custom[myProperty] = customProperties[myProperty]
      }
      data.customer.email = contactDetails.Email
      data.customer.phone = contactDetails.formattedPhone
      data.customer.firstName = contactDetails.FirstName
      data.customer.lastName = contactDetails.LastName
      data.customer.dateOfBirth = contactDetails.DOB
      data.customer.externalId = contactDetails.CustRef
      data.customer.allowOverwrite = contactDetails.allowOverwrite
      data.languageCode = languageCode
      data.custom = JSON.stringify(data.custom)
      if (recaptchaToken) {
        data.captcha = recaptchaToken
      }
      if (notificationType) {
        data.notificationType = notificationType
      }
      data.notes = notes // contactDetails.Notes
      if (contactDetails.AppRef) {
        data.appointmentReference = contactDetails.AppRef
        data.title = contactDetails.AppRef
      }
      var json = JSON.stringify(data)
      return axios.post(url, json, {
        headers: { 'X-CSRF-Token': securityToken } }
      )
    },
    matchCustomer: function (contactDetails, securityToken) {
      var url = '/matchCustomer'
      var data = {}
      data.email = contactDetails.Email
      data.phone = contactDetails.formattedPhone
      data.firstName = contactDetails.FirstName
      data.lastName = contactDetails.LastName
      data.dateOfBirth = contactDetails.DOB
      data.externalId = contactDetails.CustRef
      var json = JSON.stringify(data)
      return axios.post(url, json, {
        headers: { 'X-CSRF-Token': securityToken } }
      )
    },
    checkRestrictions: function (phone, email, branch, services, date, time, custRef) {
      var string = ';phone=' + phone
      if (email) {
        string += ';email=' + email
      }
      if (custRef) {
        string += ';custRef=' + custRef
      }
      string += ';branchPublicId=' + branch.id
      string += ';servicePublicId=' + services[0].publicId + ';date=' + date + ';time=' + time
      return axios.get('/appointments/checkMultiple' + string)
    },
    getAppointment: function (appointmentId) {
      return axios.get('/appointment/' + appointmentId)
    },
    deleteAppointment: function (appointmentId) {
      return axios.delete('/appointments/' + appointmentId)
    },
    releaseTimeslot: function (appointmentId) {
      return axios.delete('/appointments/reserved/' + appointmentId)
    },
    rescheduleAppointment: function (appointment, recaptchaToken, time, date, securityToken) {
      var createdByUser = 'Qmatic Web Booking'
      var data = {
        title: createdByUser
      }
      if (recaptchaToken) {
        data.captcha = recaptchaToken
      }
      data.time = time
      data.date = date
      data.custom = {
        createdByUser: createdByUser
      }
      data.custom.peopleServices = appointment.peopleServices
      data.custom.totalCost = appointment.totalCost
      data.custom.customSlotLength = appointment.customSlotLength
      data.customer = {}
      data.customer.id = appointment.customer.id
      data.services = appointment.services
      data.publicBranchId = appointment.publicBranchId
      data.languageCode = appointment.languageCode
      data.externalId = appointment.externalId
      data.custom = JSON.stringify(data.custom)
      var json = JSON.stringify(data)
      return axios.post('/appointments/' + appointment.publicId + '/reschedule', json, {
        headers: { 'X-CSRF-Token': securityToken } }
      )
    },
    findAppointment: function (userinput, captcha, securityToken, useBookingId) {
      var url = '/appointments/search'
      var data = {}
      data.firstName = userinput.FirstName
      data.lastName = userinput.LastName
      data.email = userinput.Email
      data.phone = userinput.formattedPhone
      data.dateOfBirth = userinput.DOB
      data.captcha = captcha
      data.externalId = userinput.CustRef
      if (userinput.AppRef && userinput.AppRef.length > 0) { url += ';appRef=' + userinput.AppRef }
      if (userinput.BookingId && userinput.BookingId.length > 0) { url += ';bookingId=' + userinput.BookingId }
      url += ';useBookingId=' + useBookingId
      var json = JSON.stringify(data)
      return axios.post(url, json, {
        headers: { 'X-CSRF-Token': securityToken } }
      )
    },
    getConditionalPrice: function (date, time) {
      var url = '/prices/dates/' + date + '/times/' + time + '/cost'
      return axios.get(url)
    },
    getAppointmentProfiles: function () {
      return axios.get('/appointmentProfiles/')
    }
  }
}
